(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glossary"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('map-glossary')) {
  customElements.define('map-glossary', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const input = this.querySelector('input');
      const terms = Array.from(this.querySelectorAll('.gloss-term'));
      const headings = Array.from(this.querySelectorAll('.gloss-divider'));
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
      const texts = terms.map(term => normalize(term.textContent));
      const update = () => {
        const words = normalize(input.value).split(' ').filter(Boolean);
        let count = 0;
        terms.forEach((term, index) => {
          term.hidden = !words.every(word => texts[index].includes(word));
          if (!term.hidden) count++;
        });
        headings.forEach(heading => {
          let sibling = heading.nextElementSibling;
          let matches = false;
          while (sibling && !sibling.classList.contains('gloss-divider')) {
            if (!sibling.hidden) matches = true;
            sibling = sibling.nextElementSibling;
          }
          heading.hidden = !matches;
          const link = Array.from(this.querySelectorAll('.gloss-nav a')).find(a => a.dataset.letter === heading.dataset.letter);
          if (link) link.hidden = !matches;
        });
        this.querySelector('.gloss-no-results').hidden = count > 0;
        this.querySelector('.gloss-count').textContent = this.dataset.count.replace('[count]', count);
      };
      input.addEventListener('input', update, options);
      this.querySelector('.gloss-clear').addEventListener('click', () => { input.value = ''; update(); input.focus(); }, options);
      this.querySelectorAll('.gloss-nav a').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (target) target.focus({ preventScroll: true });
      }, options));
      this.querySelector('.gloss-tools').hidden = false;
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-filters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('resources-filter-controls')) {
  customElements.define('resources-filter-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.currentURL = new URL(window.location.href);
      this.status = this.querySelector('[data-filter-status]');
      this.error = this.querySelector('[data-filter-error]');
      const options = { signal: this.events.signal };
      document.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const grid = document.querySelector('.resources-blog[data-section-id]');
        const isFilter = this.contains(link) && link.closest('.resources-filters__list');
        const isPagination = grid && grid.contains(link) && link.closest('.resources-pagination');
        if (!grid || (!isFilter && !isPagination)) return;
        const url = new URL(link.href);
        if (!this.accepts(url)) return;
        event.preventDefault();
        url.hash = '';
        this.load(url, { pagination: Boolean(isPagination) });
      }, options);
      window.addEventListener('popstate', event => {
        const url = new URL(window.location.href);
        if (this.accepts(url) && (url.pathname !== this.currentURL.pathname || url.search !== this.currentURL.search)) {
          this.load(url, { history: true, scroll: event.state?.resourcesFilterScroll });
        }
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      this.events = null;
    }
    accepts(url) {
      const base = new URL(this.dataset.blogUrl, window.location.origin);
      return url.origin === base.origin && (url.pathname === base.pathname || url.pathname.startsWith(base.pathname + '/tagged/'));
    }
    async load(url, options = {}) {
      const grid = document.querySelector('.resources-blog[data-section-id]');
      if (!grid) return;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.error.hidden = true;
      this.status.textContent = this.dataset.loading;
      grid.setAttribute('aria-busy', 'true');
      const sectionURL = new URL(url);
      sectionURL.hash = '';
      sectionURL.searchParams.set('sections', [this.dataset.sectionId, grid.dataset.sectionId].join(','));
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) sectionURL.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(sectionURL, { signal: request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Section request failed');
        const sections = await response.json();
        if (typeof sections[this.dataset.sectionId] !== 'string' || typeof sections[grid.dataset.sectionId] !== 'string') throw new Error('Missing section');
        const parser = new DOMParser();
        const nextGrid = parser.parseFromString(sections[grid.dataset.sectionId], 'text/html').querySelector('.resources-blog');
        const nextFilters = parser.parseFromString(sections[this.dataset.sectionId], 'text/html').querySelector('resources-filter-controls');
        if (!nextGrid || !nextFilters) throw new Error('Invalid section');
        if (request.signal.aborted) return;
        const scroll = window.scrollY;
        const active = nextFilters.querySelector('[aria-current="page"]');
        const activePath = active ? new URL(active.href, window.location.origin).pathname : '';
        if (!options.history) {
          history.replaceState({ ...history.state, resourcesFilterScroll: scroll }, '', window.location.href);
          history.pushState({ ...history.state, resourcesFilterScroll: scroll }, '', url);
        }
        grid.replaceWith(nextGrid);
        this.querySelectorAll('.resources-filters__list a').forEach(link => {
          const selected = new URL(link.href).pathname === activePath;
          link.classList.toggle('is-active', selected);
          if (selected) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        this.currentURL = new URL(url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical && nextGrid.dataset.canonical) canonical.href = nextGrid.dataset.canonical;
        this.status.textContent = this.dataset.loaded.replace('[count]', nextGrid.querySelectorAll('.resource-post').length);
        if (options.pagination) {
          const heading = nextGrid.querySelector('.resources-blog__heading');
          heading.focus({ preventScroll: true });
          this.scrollIntoView({ block: 'start', behavior: 'instant' });
          history.replaceState({ ...history.state, resourcesFilterScroll: window.scrollY }, '', window.location.href);
        } else {
          window.scrollTo({ top: Number.isFinite(options.scroll) ? options.scroll : scroll, behavior: 'instant' });
        }
      } catch (error) {
        if (request.signal.aborted) return;
        this.status.textContent = '';
        this.error.hidden = false;
        if (options.history) history.replaceState(history.state, '', this.currentURL);
      } finally {
        if (this.request === request) {
          document.querySelector('.resources-blog')?.removeAttribute('aria-busy');
          this.request = null;
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
